document.querySelectorAll('.bi-card__purchase form').forEach((form) => {
  const size = form.querySelector('.bi-size-select');
  const variant = form.querySelector('input[name="id"]');
  const addButton = form.querySelector('button[name="add"]');
  const syncSize = () => {
    variant.value = size.value;
    addButton.disabled = !size.value;
    variant.dispatchEvent(new Event('change', { bubbles: true }));
  };
  size.addEventListener('change', syncSize);
  syncSize();
});

const insoleBottomBuy = document.querySelector('.bi-bottom-buy');
if (insoleBottomBuy) {
  const form = insoleBottomBuy.querySelector('form');
  const choice = form.querySelector('.bi-bottom-buy__variant');
  const variant = form.querySelector('input[name="id"]');
  const addButton = form.querySelector('button[name="add"]');
  const sticky = document.querySelector('.bi-sticky-buy');
  const stickyButton = sticky.querySelector('[data-bi-sticky-buy]');
  const products = document.querySelector('.bi-products');

  choice.addEventListener('change', () => {
    variant.value = choice.value;
    addButton.disabled = !choice.value;
    stickyButton.textContent = choice.value ? 'הוספה לסל' : 'בחירת מדרס';
    variant.dispatchEvent(new Event('change', { bubbles: true }));
  });

  stickyButton.addEventListener('click', () => {
    if (choice.value) form.requestSubmit();
    else insoleBottomBuy.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  const updateSticky = () => {
    const productsAbove = products.getBoundingClientRect().bottom < 0;
    const buyRect = insoleBottomBuy.getBoundingClientRect();
    const buyVisible = buyRect.top < window.innerHeight && buyRect.bottom > 0;
    sticky.hidden = !productsAbove || buyVisible;
  };
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();
}
